import React from "react";
import styled from "@emotion/styled";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material";
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import { theme } from "../../../theme";
import { FormattedMessage } from "react-intl";

export const FAQStudentsAccordionSection = () => {
  return (
    <AccordionContainer>
      <Accordion>
        <StyledAccordionSummary expandIcon={<ExpandMoreIcon />}>
          <FormattedMessage id={"faq.students.find-teacher.title"} />
        </StyledAccordionSummary>
        <StyledAccordionDetails>
          <AccordionDetailsTitle>
            <FormattedMessage id={"faq.students.find-teacher.subtitle1"} />
          </AccordionDetailsTitle>
          <AccordionDetailsText>
            <FormattedMessage id={"faq.students.find-teacher.text1"} />
          </AccordionDetailsText>
          <AccordionDetailsTitle>
            <FormattedMessage id={"faq.students.find-teacher.subtitle2"} />
          </AccordionDetailsTitle>
          <AccordionDetailsText>
            <FormattedMessage id={"faq.students.find-teacher.text2"} />
          </AccordionDetailsText>
        </StyledAccordionDetails>
      </Accordion>

      <Accordion>
        <StyledAccordionSummary expandIcon={<ExpandMoreIcon />}>
          <FormattedMessage id={"faq.students.find-courses.title"} />
        </StyledAccordionSummary>
        <StyledAccordionDetails>
          <AccordionDetailsTitle>
            <FormattedMessage id={"faq.students.find-courses.subtitle1"} />
          </AccordionDetailsTitle>
          <AccordionDetailsText>
            <FormattedMessage id={"faq.students.find-courses.text1"} />
          </AccordionDetailsText>
        </StyledAccordionDetails>
      </Accordion>

      <Accordion>
        <StyledAccordionSummary expandIcon={<ExpandMoreIcon />}>
          <FormattedMessage id={"faq.students.communication.title"} />
        </StyledAccordionSummary>
        <StyledAccordionDetails>
          <AccordionDetailsTitle>
            <FormattedMessage id={"faq.students.communication.subtitle1"} />
          </AccordionDetailsTitle>
          <AccordionDetailsText>
            <FormattedMessage id={"faq.students.communication.text1"} />
          </AccordionDetailsText>
          <AccordionDetailsTitle>
            <FormattedMessage id={"faq.students.communication.subtitle2"} />
          </AccordionDetailsTitle>
          <AccordionDetailsText>
            <FormattedMessage id={"faq.students.communication.text2"} />
          </AccordionDetailsText>
        </StyledAccordionDetails>
      </Accordion>

      <Accordion>
        <StyledAccordionSummary expandIcon={<ExpandMoreIcon />}>
          <FormattedMessage id={"faq.students.manage-courses.title"} />
        </StyledAccordionSummary>
        <StyledAccordionDetails>
          <AccordionDetailsTitle>
            <FormattedMessage id={"faq.students.manage-courses.subtitle1"} />
          </AccordionDetailsTitle>
          <AccordionDetailsText>
            <FormattedMessage id={"faq.students.manage-courses.text1"} />
          </AccordionDetailsText>
          <AccordionDetailsTitle>
            <FormattedMessage id={"faq.students.manage-courses.subtitle2"} />
          </AccordionDetailsTitle>
          <AccordionDetailsText>
            <FormattedMessage id={"faq.students.manage-courses.text2"} />
          </AccordionDetailsText>
          <AccordionDetailsTitle>
            <FormattedMessage id={"faq.students.manage-courses.subtitle3"} />
          </AccordionDetailsTitle>
          <AccordionDetailsText>
            <FormattedMessage id={"faq.students.manage-courses.text3"} />
          </AccordionDetailsText>
        </StyledAccordionDetails>
      </Accordion>

      <Accordion>
        <StyledAccordionSummary expandIcon={<ExpandMoreIcon />}>
          <FormattedMessage id={"faq.students.payment.title"} />
        </StyledAccordionSummary>
        <StyledAccordionDetails>
          <AccordionDetailsTitle>
            <FormattedMessage id={"faq.students.payment.subtitle1"} />
          </AccordionDetailsTitle>
          <AccordionDetailsText>
            <FormattedMessage id={"faq.students.payment.text1"} />
          </AccordionDetailsText>
        </StyledAccordionDetails>
      </Accordion>

      <Accordion>
        <StyledAccordionSummary expandIcon={<ExpandMoreIcon />}>
          <FormattedMessage id={"faq.students.manage-profile.title"} />
        </StyledAccordionSummary>
        <StyledAccordionDetails>
          <AccordionDetailsTitle>
            <FormattedMessage id={"faq.students.manage-profile.subtitle1"} />
          </AccordionDetailsTitle>
          <AccordionDetailsText>
            <FormattedMessage id={"faq.students.manage-profile.text1"} />
          </AccordionDetailsText>
          <AccordionDetailsTitle>
            <FormattedMessage id={"faq.students.manage-profile.subtitle2"} />
          </AccordionDetailsTitle>
          <AccordionDetailsText>
            <FormattedMessage id={"faq.students.manage-profile.text2"} />
          </AccordionDetailsText>
        </StyledAccordionDetails>
      </Accordion>

      <Accordion>
        <StyledAccordionSummary expandIcon={<ExpandMoreIcon />}>
          <FormattedMessage id={"faq.students.vacation-mode.title"} />
        </StyledAccordionSummary>
        <StyledAccordionDetails>
          <AccordionDetailsTitle>
            <FormattedMessage id={"faq.students.vacation-mode.subtitle1"} />
          </AccordionDetailsTitle>
          <AccordionDetailsText>
            <FormattedMessage id={"faq.students.vacation-mode.text1"} />
          </AccordionDetailsText>
          <AccordionDetailsTitle>
            <FormattedMessage id={"faq.students.vacation-mode.subtitle2"} />
          </AccordionDetailsTitle>
          <AccordionDetailsText>
            <FormattedMessage id={"faq.students.vacation-mode.text2"} />
          </AccordionDetailsText>
        </StyledAccordionDetails>
      </Accordion>

      <Accordion>
        <StyledAccordionSummary expandIcon={<ExpandMoreIcon />}>
          <FormattedMessage id={"faq.students.subscribe.title"} />
        </StyledAccordionSummary>
        <StyledAccordionDetails>
          <AccordionDetailsTitle>
            <FormattedMessage id={"faq.students.subscribe.subtitle1"} />
          </AccordionDetailsTitle>
          <AccordionDetailsText>
            <FormattedMessage id={"faq.students.subscribe.text1"} />
          </AccordionDetailsText>
          <AccordionDetailsTitle>
            <FormattedMessage id={"faq.students.subscribe.subtitle2"} />
          </AccordionDetailsTitle>
          <AccordionDetailsText>
            <FormattedMessage id={"faq.students.subscribe.text2"} />
          </AccordionDetailsText>
        </StyledAccordionDetails>
      </Accordion>
    </AccordionContainer>
  );
};

const AccordionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  box-sizing: border-box;
`;

const StyledAccordionSummary = styled(AccordionSummary)`
  && {
    background: ${props => props.theme.primaryColor};
    color: white;
    font-weight: 600;
    font-size: 1.1rem;
    min-height: 60px;
    border-radius: 8px 8px 0 0;
    
    &:hover {
      background: ${props => props.theme.hoverColor};
    }
    
    .MuiAccordionSummary-content {
      margin: 12px 0;
    }
    
    .MuiAccordionSummary-expandIconWrapper {
      color: white;
    }
  }
`;

const StyledAccordionDetails = styled(AccordionDetails)`
  && {
    background: ${props => props.theme.primary + '10'};
    border-radius: 0 0 8px 8px;
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    
    @media (max-width: 768px) {
      padding: 1rem;
    }
  }
`;

const AccordionDetailsTitle = styled.div`
  color: ${props => props.theme.mainTextColor};
  font-weight: 600;
  font-size: 1rem;
  margin-bottom: 0.5rem;
`;

const AccordionDetailsText = styled.div`
  color: ${props => props.theme.mainTextColor};
  font-size: 0.95rem;
  line-height: 1.6;
  margin-bottom: 1rem;
  
  &:last-child {
    margin-bottom: 0;
  }
`;
